import { getPageRange } from '@/utils/pagination';
import { COPY } from '@/lib/copy';

type Props = {
  currentPage: number;
  totalPages: number;
  onGoToPage: (page: number) => void;
};

const { pagination } = COPY.blog;

export default function BlogPagination({
  currentPage,
  totalPages,
  onGoToPage,
}: Props) {
  if (totalPages <= 1) return null;

  return (
    <nav
      aria-label={pagination.navLabel}
      className="flex items-center justify-center gap-[0.4rem] px-[6vw] py-12 border-t border-bg-alt bg-bg-main"
    >
      <button
        onClick={() => onGoToPage(currentPage - 1)}
        disabled={currentPage === 1}
        aria-label={pagination.prevLabel}
        className="inline-flex items-center justify-center h-9 px-4 border border-bg-alt bg-white text-[var(--text-mid)] font-sans text-[0.68rem] tracking-[0.1em] uppercase transition-all cursor-pointer hover:border-primary hover:text-primary disabled:opacity-50 disabled:cursor-default disabled:pointer-events-none"
      >
        {pagination.prevText}
      </button>

      <div className="flex gap-[0.4rem]">
        {getPageRange(currentPage, totalPages).map((p, i) =>
          p === '...' ? (
            <span
              key={`ellipsis-${i}`}
              className="inline-flex items-center px-[0.4rem] text-[var(--text-light)] font-sans text-[0.78rem]"
            >
              …
            </span>
          ) : (
            <button
              key={p}
              onClick={() => onGoToPage(p)}
              aria-label={pagination.pageLabel(p)}
              aria-current={p === currentPage ? 'page' : undefined}
              className={[
                'inline-flex items-center justify-center min-w-[36px] h-9 border font-sans text-[0.78rem] transition-all px-[0.5rem] cursor-pointer',
                p === currentPage
                  ? 'bg-primary border-primary text-white'
                  : 'bg-white border-bg-alt text-[var(--text-mid)] hover:border-primary hover:text-primary',
              ].join(' ')}
            >
              {p}
            </button>
          ),
        )}
      </div>

      <button
        onClick={() => onGoToPage(currentPage + 1)}
        disabled={currentPage === totalPages}
        aria-label={pagination.nextLabel}
        className="inline-flex items-center justify-center h-9 px-4 border border-bg-alt bg-white text-[var(--text-mid)] font-sans text-[0.68rem] tracking-[0.1em] uppercase transition-all cursor-pointer hover:border-primary hover:text-primary disabled:opacity-50 disabled:cursor-default disabled:pointer-events-none"
      >
        {pagination.nextText}
      </button>
    </nav>
  );
}
